import React from 'react'

import { ThreadModel } from '@flowwai-frontend/shared-web/ai-chat-support/data-access'
import { ThreadDetailedViewBody } from '@flowwai-frontend/shared-web/ai-chat-support/ui'
import { useAIChatSupport } from '../../hooks/useAIChatSupport'

interface Props {
   threadModel: ThreadModel
   hasMoreMessagesToFetch: boolean
   fetchMoreMessages: () => void
}

const ThreadSubscriptionController = (props: Props) => {
   useAIChatSupport(props.threadModel)

   return <ThreadDetailedViewBody {...props} />
}

export default ThreadSubscriptionController
